import {Spin} from "antd";
import {LoadingSpinner, SVG2} from "../icons/icons";

const FullPageLoader = () => {
  return (
    <Spin
      spinning
      indicator={
        // <div>
        // <SVG2 />
        // </div>
        LoadingSpinner
      }
    >
      <div
        style={{
          height: "100vh",
        }}
      ></div>
    </Spin>
  );
};

export {FullPageLoader};
